import api from './api';

export const getCalculations = async () => {
  const { data } = await api.get('/calculations');
  return data;
};

export const getCalculation = async (id) => {
  const { data } = await api.get(`/calculations/${id}`);
  return data;
};

export const createCalculation = async (params) => {
  const { data } = await api.post('/calculations', params);
  return data;
};

export const updateCalculation = async (id, params) => {
  const { data } = await api.put(`/calculations/${id}`, params);
  return data;
};

export const deleteCalculation = async (id) => {
  const { data } = await api.delete(`/calculations/${id}`);
  return data;
};
